import { FC } from "react";
import { AuthenticatedLayout } from "../../../layouts";
import { YearToDateReport } from "../../../components/Reports/YearToDateReport";

export interface IYearToDateReportPage {}

export const YearToDateReportPage: FC<IYearToDateReportPage> = () => {
	return (
		<AuthenticatedLayout
			pageTitle="Year To Date Report"
			breadcrumbCurrentPageName=""
			breadcrumbLinks={[]}
			mainContents={<YearToDateReport />}
		/>
	);
};
